module.exports = __webpack_public_path__ + "static/img/course_arrange_widget_2.6631e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/course_arrange_widget_2.png
// module id = kRWx
// module chunks = 11